import { slideDown, slideUp } from '../libs/sliding';
import { prefersReducedMotion } from '../utils/prefersReducedMotion';

const jumpOffModal = document.querySelector('#jump-off-modal');
const jumpOffModalLinks =
  jumpOffModal && Array.from(jumpOffModal.querySelectorAll('[tabindex]'));
const toggle = document.querySelector('#navigation-header-toggle');
const menu = document.querySelector('#navigation-header');
const header = document.querySelector('#header');
const navHorizontal = document.querySelector(
  '.nav-horizontal-with-aux .nav-horizontal',
);
const toggleSub = Array.from(
  document.querySelectorAll('.nav-vertical__toggle'),
);
const searchContainer = document.querySelector('.nav-horizontal__search');

const collapsedSearchContainer = document.querySelector(
  '#collapsed-nav-search',
);
const searchOpenButton = document.querySelector(
  '[data-js-collapsed-search-open-trigger]',
);
const collapsedSearchInputs =
  collapsedSearchContainer &&
  Array.from(collapsedSearchContainer.querySelectorAll('[tabindex]'));

let isModalOpen = false;
let isSearchOpen = false;
let isCollapsedSearchOpen = false;

function trapFocus(element, activeClass) {
  const focusableEls = element.querySelectorAll(
    'a[href]:not([tabindex="-1"]), button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled])',
  );
  const firstFocusableEl = focusableEls[0];
  const lastFocusableEl = focusableEls[focusableEls.length - 1];
  const KEYCODE_TAB = 9;

  element.addEventListener('keydown', (e) => {
    if (activeClass != null) {
      if (element.classList.contains(activeClass)) {
        const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;

        if (!isTabPressed) {
          return;
        }

        if (e.shiftKey) {
          // shift + tab
          if (document.activeElement === firstFocusableEl) {
            lastFocusableEl.focus();
            e.preventDefault();
          }
        } else if (document.activeElement === lastFocusableEl) {
          // tab
          firstFocusableEl.focus();
          e.preventDefault();
        }
      }
    }
  });
}

const openJumpOffModal = () => {
  isModalOpen = true;

  // If the main navigation menu is open, we need to close it.
  if (menu.classList.contains('navigation-header--active')) {
    toggle && toggle.click();
  }

  document.body.classList.add(
    'modal-open',
    'jump-off-modal-active',
    'jump-off-modal-body-active',
    'jump-off-modal-overlay-active',
  );

  // Make jump-off modal tabbable.
  jumpOffModalLinks.forEach((link) => link.removeAttribute('tabindex'));
  jumpOffModal.setAttribute('aria-hidden', 'false');

  trapFocus(jumpOffModal);
};
const closeJumpOffModal = () => {
  isModalOpen = false;

  document.body.classList.remove(
    'modal-open',
    'jump-off-modal-body-active',
    'jump-off-modal-overlay-active',
  );

  // Make jump-off modal not tabbable.
  jumpOffModalLinks.forEach((link) => link.setAttribute('tabindex', '-1'));
  jumpOffModal.setAttribute('aria-hidden', 'true');

  // Wait for the animation to complete before closing the modal completely.
  setTimeout(() => {
    document.body.classList.remove('jump-off-modal-active');
  }, 350);
};

// collapsed search from here:
const closeCollapsedSearchModal = () => {
  isCollapsedSearchOpen = false;

  document.body.classList.remove('modal-open');

  collapsedSearchContainer.classList.remove('collapsed-nav-search--open');

  // Make collapsed Search modal not tabbable.
  collapsedSearchInputs.forEach((input) =>
    input.setAttribute('tabindex', '-1'),
  );
  collapsedSearchContainer.setAttribute('aria-hidden', 'true');
  collapsedSearchContainer.setAttribute('inert', '');
};

const openCollapsedSearchModal = () => {
  isCollapsedSearchOpen = true;

  // If the main navigation menu is open, we need to close it.
  if (menu.classList.contains('navigation-header--active')) {
    toggle && toggle.click();
  }

  document.body.classList.add('modal-open');

  collapsedSearchContainer.classList.add('collapsed-nav-search--open');

  // Make collapsed Search modal tabbable.
  collapsedSearchInputs.forEach((input) => input.removeAttribute('tabindex'));
  collapsedSearchContainer.setAttribute('aria-hidden', 'false');
  collapsedSearchContainer.removeAttribute('inert');
  trapFocus(collapsedSearchContainer, 'collapsed-nav-search--open');
};

function navHeaderFunc() {
  if (header) {
    const tabIndexi = document.querySelectorAll('.c-header [tabindex]');

    toggle &&
      toggle.addEventListener('click', () => {
        if (menu.classList.contains('navigation-header--active')) {
          // Close the main navigation menu.
          header.classList.remove('c-header--active');
          toggle.classList.remove('hamburger__active');
          toggle.classList.add('hamburger__active-removed');
          document.body.classList.remove('modal-open');
          toggle.setAttribute('aria-expanded', 'false');

          // add/remove aria-hidden to nav horizontal
          if (navHorizontal) {
            navHorizontal.setAttribute('aria-hidden', 'true');
          }

          for (let i = 0; i < tabIndexi.length; i += 1) {
            tabIndexi[i].setAttribute('tabindex', '-1');
          }

          // show the search trigger icon when the menu is close
          if (
            searchOpenButton &&
            searchOpenButton.classList.contains('u-visuallyhidden')
          ) {
            searchOpenButton.classList.remove('u-visuallyhidden');
          }

          setTimeout(() => {
            document.documentElement.scrollTop = document.body.scrollTop =
              window
                .getComputedStyle(document.body)
                .getPropertyValue('top')
                .replace('px', '') * -1;

            menu.classList.remove('navigation-header--open');
          }, 1);

          setTimeout(() => {
            menu.classList.remove('navigation-header--active');
          }, 500);
        } else {
          // Open the main navigation menu.
          if (isModalOpen) {
            closeJumpOffModal();
          }

          if (isCollapsedSearchOpen) {
            closeCollapsedSearchModal();
          }

          searchOpenButton &&
            searchOpenButton.classList.add('u-visuallyhidden');

          // TODO: setAttribute expects second param to be a string, can't passing it an HTMLElement.
          // const focusState = document.activeElement;
          // document.body.setAttribute('data-focussed', focusState);

          document.body.style.top = `-${
            window.pageYOffset || document.documentElement.scrollTop || 0
          }px`;

          for (let i = 0; i < tabIndexi.length; i += 1) {
            tabIndexi[i].setAttribute('tabindex', '0');
          }

          setTimeout(() => {
            menu.classList.add('navigation-header--active');
            header.classList.add('c-header--active');
            toggle.classList.add('hamburger__active');
            toggle.classList.remove('hamburger__active-removed');
            document.body.classList.add('modal-open');
            toggle.setAttribute('aria-expanded', 'true');
            if (navHorizontal) {
              navHorizontal.setAttribute('aria-hidden', 'false');
            }
          }, 1);

          setTimeout(() => {
            menu.classList.add('navigation-header--open');
          }, 10);
        }
      });
    trapFocus(header, 'c-header--active');
  }
}

function initJumpOffModal() {
  const donateButton = document.querySelector('#nav-donate');
  const closeButtons = Array.from(
    document.querySelectorAll('[data-jump-off-close-trigger]'),
  );

  // If we don't have a 'donate' button in the header, we do nothing.
  if (!donateButton || !jumpOffModal) return;

  donateButton.addEventListener('click', (e) => {
    e.preventDefault();

    isModalOpen ? closeJumpOffModal() : openJumpOffModal();
  });

  // If there are close triggers, attach a click event for them.
  closeButtons.length &&
    closeButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();

        closeJumpOffModal();
      });
    });
}

function initCollapsedSearch() {
  const searchCloseButtons = Array.from(
    document.querySelectorAll('[data-js-collapsed-search-close-trigger]'),
  );

  // If we don't have a 'donate' button in the header, we do nothing.
  if (!searchOpenButton || !searchCloseButtons) return;

  searchOpenButton.addEventListener('click', () => {
    isCollapsedSearchOpen
      ? closeCollapsedSearchModal()
      : openCollapsedSearchModal();
  });

  // Allow user to close the modal by pressing the escape key.
  document.addEventListener('keyup', (event) => {
    if (
      (event.key === 'Escape' || event.key === 'Esc') &&
      isCollapsedSearchOpen
    ) {
      closeCollapsedSearchModal();
    }
  });

  // If there are close triggers, attach a click event for them.
  searchCloseButtons.length &&
    searchCloseButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();

        closeCollapsedSearchModal();
      });
    });
}

function navHeaderToggleSub() {
  const duration = prefersReducedMotion() ? 0 : 450;
  toggleSub.length &&
    toggleSub.forEach((t) => {
      t.addEventListener('click', () => {
        const slide = t
          .closest('.nav-vertical__level-1')
          .parentNode.querySelector('.nav-vertical__list');
        const parentElem = t.closest('.nav-vertical__level-1').parentNode;

        if (parentElem.classList.contains('level-2--active')) {
          parentElem.classList.remove('level-2--active');
          t.setAttribute('aria-expanded', false);
          slideUp(slide, duration);
        } else {
          parentElem.classList.add('level-2--active');
          t.setAttribute('aria-expanded', true);
          slideDown(slide, duration);
        }
      });
    });
}

function showHideSearch() {
  const searchButton = document.querySelectorAll('[data-js-search]');

  // If we don't have a 'search' button in the header, we do nothing.
  if (!searchButton || !searchContainer) return;

  [...searchButton].forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();

      isSearchOpen = !isSearchOpen;

      button.setAttribute('aria-expanded', isSearchOpen);
      searchContainer.classList.toggle(
        'nav-horizontal__search--hidden',
        !isSearchOpen,
      );
    });
  });
}

export function init() {
  navHeaderFunc();
  navHeaderToggleSub();
  initJumpOffModal();
  showHideSearch();
  initCollapsedSearch();
}
